export const Blog_Schema = {
  "@context": "https://schema.org",
  "@type": "Article",
  mainEntityOfPage: {},
  headline: "",
  description: "",
  image: "",
  // TODO : Static name of blog author we can add one field in wordpress to make it dynamic
  author: {
    "@type": "Person",
    name: "Bhoomi Ramanandi",
  },
  publisher: {
    "@type": "Organization",
    name: "Agile Infoways LLC",
    logo: {
      "@type": "ImageObject",
      url: "",
    },
  },
  datePublished: "2023-04-03",
}
